<template>
  <b-row>
    <b-col cols="12">
      <div class="d-flex justify-content-end my-1">
        <b-button v-if="HasPermission(PermissionList.Sales_Create)" variant="primary" @click="sendSO()">
          <span class="text-nowrap">Add Proforma</span>
        </b-button>
      </div>
    </b-col>
    <!-- search input -->
    <b-col md="2" sm="4" class="my-1">
      <b-form-group class="mb-0">
        <label class="d-inline-block text-sm-left mr-50">Per page</label>
        <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="w-50" />
      </b-form-group>
    </b-col>

    <b-col cols="12" class="d-flex justify-content-end mb-2" style="position: relative; z-index: 1;">
      <b-button variant="outline-danger" size="sm" @click="clearFilters">
        Clear Filters
      </b-button>
    </b-col>

    <b-col cols="12">
      <b-table striped hover responsive :per-page="perPage" :current-page="currentPage" :items="filteredOrders"
        :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
        @filtered="onFiltered">

        <!-- ISSUE DATE Filter -->
        <template #head(issuedDate)="scope">
          <div class="d-flex flex-column">
            <span @click="toggleSort('issuedDate')" style="cursor: pointer">Issue Date</span>
            <DatePicker v-model="filters.issuedDateRange" range format="YYYY-MM-DD" placeholder="Select date range"
              @change="applyDateFilters" style="width: 100%;" />
          </div>
        </template>

        <!-- Created On Filter -->
        <template #head(createdOn)="scope">
          <div class="d-flex flex-column">
            <span @click="toggleSort('createdOn')" style="cursor: pointer">Created On</span>
            <DatePicker v-model="filters.createdOnRange" range format="YYYY-MM-DD" placeholder="Select date range"
              @change="applyDateFilters" style="width: 100%;" />
          </div>
        </template>

        <!-- Due Date Filter -->
        <template #head(dueDate)="scope">
          <div class="d-flex flex-column">
            <span @click="toggleSort('dueDate')" style="cursor: pointer">Due Date</span>
            <DatePicker v-model="filters.dueDateRange" range format="YYYY-MM-DD" placeholder="Select date range"
              @change="applyDateFilters" style="width: 100%;" />
          </div>
        </template>

        <!-- ORDER TYPE Dropdown Filter -->
        <!-- <template #head(orderType)="scope">
          <div class="d-flex flex-column">
            <span>Order Type</span>
            <b-form-select v-model="filters.orderType" :options="orderTypeOptions" @change="applyFilters" />
          </div>
        </template> -->

        <!-- STATUS Dropdown Filter -->
        <template #head(status)="scope">
          <div class="d-flex flex-column">
            <span>Status</span>
            <b-form-select v-model="filters.status" :options="statusOptions" @change="applyFilters" />
          </div>
        </template>

        <template v-slot:cell(total)="data">
          Rs {{ data.item.total.toFixed(2) }}
        </template>
        <template v-slot:cell(issuedDate)="data">
          {{ convertTimestampToDate(data.item.issuedDate) }}
        </template>
        <template #cell(orderType)="data">
          <!-- <b-badge v-if="data.item.orderType === 0" variant="primary">
            Fixed Order
          </b-badge> -->
          <b-badge v-if="data.item.orderType === 1" variant="primary">
            Variable Order
          </b-badge>
          <b-badge v-else-if="data.item.orderType === 2" variant="primary">
            OneOff Order
          </b-badge>
        </template>
        <template #cell(status)="data">
          <b-badge v-if="data.item.status === 0" variant="secondary"> PROFORMA </b-badge>
          <b-badge v-else-if="data.item.status === 1" variant="warning">
            ONDEMAND
          </b-badge>
          <b-badge v-else-if="data.item.status === 2" variant="info">
            READY
          </b-badge>
          <b-badge v-else-if="data.item.status === 3" variant="info">
            INVOICED
          </b-badge>
          <b-badge v-else-if="data.item.status === 4" variant="info">
            CANCELLED
          </b-badge>
          <b-badge v-else variant="danger"> Blocked </b-badge>
        </template>
        <template v-slot:cell(createdOn)="data">
          {{ convertTimestampToDate(data.item.createdOn) }}
        </template>
        <template v-slot:cell(dueDate)="data">
          {{ convertTimestampToDate(data.item.dueDate) }}
        </template>
        <template #cell(actions)="data">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template v-slot:button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
            </template>
            <b-dropdown-item v-if="HasPermission(PermissionList.Sales_View)" :to="getSalesOrderIdView(data.item.id)">
              <feather-icon icon="EyeIcon" class="mr-50" />
              <span>View</span>
            </b-dropdown-item>
            <b-dropdown-item v-if="isEdit" :disabled="data.item.status == 3" :to="getSalesOrderId(data.item.id)">
              <feather-icon icon="Edit2Icon" class="mr-50" />
              <span>Edit</span>
            </b-dropdown-item>
            <b-dropdown-item v-if="HasPermission(PermissionList.Sales_Delete)" @click="removesalesOrder(data.item.id)">
              <feather-icon icon="TrashIcon" class="mr-50" />
              <span>Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <div class="d-flex justify-content-center mb-1">
        <b-alert variant="warning" show v-if="order.length === 0" class="d-flex justify-content-center">
          <h4 class="alert-heading">No Proformas yet</h4>
        </b-alert>
      </div>
      <div class="d-flex justify-content-center mb-1">
        <b-spinner variant="success" label="Spinning" block v-if="loading"
          style="width: 3rem; height: 3rem"></b-spinner>
      </div>
    </b-col>

    <b-col cols="12">
      <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center" size="sm"
        class="my-0" />
    </b-col>
  </b-row>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import {
  BTable,
  BAvatar,
  BAlert,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BSpinner,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import { PermissionList } from '@/libs/defaultList';
import { HasPermission } from '@/@core/utils/validations/permissionCheck';

import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BAlert,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BDropdown,
    BDropdownItem,
    DatePicker,
  },
  data() {
    return {
      id: this.$route.params.id,
      leadClientName: "",
      total: "",
      issuedDate: "",
      orderType: "",
      isActive: 1,
      status: "",
      isEdit: false,
      salesOrderData: [],
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      filters: {
        issuedDateRange: [null, null],
        createdOnRange: [null, null],
        dueDateRange: [null, null],
        orderType: null,
        status: null,
      },
      orderTypeOptions: [
        { value: null, text: 'All' },
        // { value: 0, text: 'Fixed Order' },
        { value: 1, text: 'Variable Order' },
        { value: 2, text: 'OneOff Order' },
      ],
      statusOptions: [
        { value: null, text: 'All' },
        { value: 0, text: 'PROFORMA' },
        { value: 1, text: 'ONDEMAND' },
        { value: 2, text: 'READY' },
        { value: 3, text: 'INVOICED' },
        { value: 4, text: 'CANCELLED' },
        { value: 5, text: 'Blocked' },
      ],
      fields: [  
      { key: "orderNumber", label: "ORDER NUMBER", sortable: true },
        { key: "issuedDate", label: "ISSUE DATE", sortable: true },
        { key: "createdOn", label: "CREATED ON", sortable: true },
        { key: "dueDate", label: "DUE DATE", sortable: true },
        { key: "orderType", label: "ORDER TYPE", sortable: true },
        { key: "status", label: "STATUS" },
        { key: "total", label: "TOTAL", sortable: true },
        "actions",
      ],
    };
  },
  computed: {
    filteredOrders() {
      return this.order.filter((item) => {
        let issuedDateMatch = true;
        let createdOnMatch = true;
        let dueDateMatch = true;
        let orderTypeMatch = true;
        let statusMatch = true;

        if (this.filters.issuedDateRange && this.filters.issuedDateRange[0] && this.filters.issuedDateRange[1]) {
          const [start, end] = this.filters.issuedDateRange.map((date) => new Date(date).getTime());
          const issuedDate = new Date(item.issuedDate).getTime();
          issuedDateMatch = issuedDate >= start && issuedDate <= end;
        }

        if (this.filters.createdOnRange && this.filters.createdOnRange[0] && this.filters.createdOnRange[1]) {
          const [start, end] = this.filters.createdOnRange.map((date) => new Date(date).getTime());
          const createdOn = new Date(item.createdOn).getTime();
          createdOnMatch = createdOn >= start && createdOn <= end;
        }

        if (this.filters.dueDateRange && this.filters.dueDateRange[0] && this.filters.dueDateRange[1]) {
          const [start, end] = this.filters.dueDateRange.map((date) => new Date(date).getTime());
          const dueDate = new Date(item.dueDate).getTime();
          dueDateMatch = dueDate >= start && dueDate <= end;
        }

        if (this.filters.orderType !== null) {
          orderTypeMatch = item.orderType === this.filters.orderType;
        }

        if (this.filters.status !== null) {
          statusMatch = item.status === this.filters.status;
        }

        return issuedDateMatch && createdOnMatch && dueDateMatch && orderTypeMatch && statusMatch;
      });
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    ...mapGetters("customerModule", {
      order: "order",
      loading: "loading",
    }),
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.order.length;
  },
  methods: {
    sendSO() {
      this.$router.push("/proforma/add/" + this.$route.params.id);
    },
    applyDateFilters() {
      this.currentPage = 1; // Reset pagination to the first page
    },
    applyFilters() {
      // When a filter is applied, reset pagination to the first page
      this.currentPage = 1;
    },
    clearFilters() {
      // Reset all filters to their initial/default values
      this.filters = {
        issuedDateRange: [null, null],
        createdOnRange: [null, null],
        dueDateRange: [null, null],
        orderType: null,
        status: null,
      };
      // Reset the filter string if applicable
      this.filter = '';
      this.currentPage = 1; // Optionally reset pagination to the first page
    },
    convertTimestampToDate(timestamp) {
      return new Date(timestamp).toLocaleDateString();
    },
    getSalesOrderIdView(data) {
      return "/proforma/view/" + data;
    },
    getsalesOrderData(data) {
      console.log(data);
      this.salesOrderData = data;
    },
    getSalesOrderId(item) {
      return "/proforma/edit/" + item;
    },

    removesalesOrder(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.removeSalesOrdersAction(id)
            .then(() => {
              this.$swal({
                icon: "success",
                title: "Deleted!",
                text: "Your file has been deleted.",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
            })
            .catch(() => {
              this.$swal({
                title: "Error",
                text: "Proforma is not deleted",
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Cancelled",
            text: "Your file is safe :)",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    ...mapActions("customerModule", ["getOrdersByIDAction"]),
    ...mapActions("salesOrderModule", ["removeSalesOrdersAction"]),
  },
  async mounted() {
    this.isEdit = HasPermission(PermissionList.Sales_Update);
    await this.getOrdersByIDAction(this.id)
      .then(() => {
        this.totalRows = this.order.length;
      })
      .catch((response) => {
        console.log(response);
      });
  },
  setup(props) {
    return {
      PermissionList,
      HasPermission
    }
  }
};
</script>
